<template>
  <power-bi
    code="eyJrIjoiY2JiYTQ1NzMtYWQxOS00NGM2LWFiMzAtYTlkODZjYzAyZjBlIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9"
  />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
